import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './index.css'
import { initTheme } from './lib/theme'

// Stamp the resolved theme on <html> before the first React render. The §12.7
// CSP forbids an inline pre-paint script, so this — running as the bundle
// executes — is the earliest a stored choice can beat the OS default that the
// CSS media query paints in the meantime.
initTheme()

const container = document.getElementById('root')
// A missing mount point is a build error, not something to work around.
if (container === null) {
  throw new Error('#root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
